import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, Shield, Menu, History, LogIn } from "lucide-react";

function AdminPage() {
  const navigate = useNavigate();

  const tiles = [
    { name: "User Management", icon: <Users size={32} />, path: "/admin/users" },
    { name: "Role Management", icon: <Shield size={32} />, path: "/admin/roles" },
    { name: "Menu Management", icon: <Menu size={32} />, path: "/admin/menus" },
    { name: "Audit History", icon: <History size={32} />, path: "/admin/audit-history" },
    { name: "Login History", icon: <LogIn size={32} />, path: "/admin/login-history" },
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Admin Dashboard</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {tiles.map((tile, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:shadow-xl transition"
            onClick={() => navigate(tile.path)}
          >
            {tile.icon}
            <span className="mt-2 font-medium">{tile.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminPage;